import { Controller } from "@hotwired/stimulus"

// Owns recovery for one lazy Turbo Frame. Turbo still owns fetching and rendering.
export default class extends Controller {
  connect() {
    const placeholder = this.element.querySelector(":scope > [data-frame-recovery-placeholder]")
    this.recoveryPlaceholder = placeholder ? placeholder.cloneNode(true) : null
  }

  missing(event) {
    if (event.target !== this.element) return
    event.preventDefault()
    this.show()
  }

  fetchError(event) {
    if (event.target !== this.element) return
    event.preventDefault()
    this.show()
  }

  click(event) {
    if (event.target.closest("turbo-frame") !== this.element) return
    if (!event.target.closest("[data-frame-recovery-retry]")) return

    event.preventDefault()
    const placeholder = this.recoveryPlaceholder?.cloneNode(true) || this.genericPlaceholder()
    this.element.replaceChildren(placeholder)
    delete this.element.dataset.error
    if (this.element.hasAttribute("src")) this.element.reload()
    else if (this.element.dataset.src) {
      this.element.loading = "eager"
      this.element.src = this.element.dataset.src
    }
  }

  genericPlaceholder() {
    const placeholder = document.createElement("div")
    placeholder.setAttribute("aria-label", "Loading")
    return placeholder
  }

  show() {
    if (document.documentElement.hasAttribute("data-connection-recovery-available")) return
    if (this.element.dataset.loaded === "true") return

    this.element.dataset.error = "true"
    const box = this.errorBox()
    const structural = this.structuralError(box)
    this.element.replaceChildren(structural || box)
  }

  errorBox() {
    const box = document.createElement("div")
    box.className = "ve-dashboard-slide-error"
    box.setAttribute("role", "alert")
    box.innerHTML = '<p>Content unavailable.</p><button type="button" class="ve-btn ve-btn-primary ve-dashboard-slide-retry" data-frame-recovery-retry>Retry</button>'

    const direct = document.createElement("a")
    direct.className = "ve-btn ve-btn-ghost"
    direct.href = this.element.dataset.directUrl || window.location.href
    direct.target = "_top"
    direct.dataset.turboFrame = "_top"
    direct.textContent = "Open directly"
    box.append(direct)
    return box
  }

  structuralError(box) {
    if (this.recoveryPlaceholder?.dataset.frameRecoveryMode !== "structural") return null

    const placeholder = this.recoveryPlaceholder.cloneNode(true)
    placeholder.removeAttribute("role")
    placeholder.removeAttribute("aria-label")
    placeholder.dataset.frameRecoveryError = "true"
    box.classList.add("ve-machine-frame-error")
    placeholder.append(box)
    return placeholder
  }
}
